import { render, staticRenderFns } from "./KLInfo.vue?vue&type=template&id=e5cff224&scoped=true"
import script from "./KLInfo.vue?vue&type=script&lang=js"
export * from "./KLInfo.vue?vue&type=script&lang=js"
import style0 from "./KLInfo.vue?vue&type=style&index=0&id=e5cff224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cff224",
  null
  
)

export default component.exports